var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon-star f-22 cr-pointer",class:_vm.estadoColor(_vm.row.estrella),on:{"click":function($event){$event.stopPropagation();return _vm.cambiar_estrella(_vm.row)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }